/* eslint-disable @next/next/no-img-element */
/** @jsxImportSource @emotion/react */
import React from 'react'
import { mq } from '../../../../helpers'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { gsColors } from '../../../../styles/Variables'
import { Section } from '../../../../styles/Components'
import Label from '../components/Label'
import Color from 'color'

import checkmarkSvg from '../../../../../public/images/checkmark.svg'

export const OPTION_ICONS = {
  location: {
    Home: <img src='/images/location-home.svg' alt='home' />,
    Hotel: <img src='/images/location-hotel.svg' alt='hotel' />,
    Office: <img src='/images/location-office.svg' alt='office' />,
    Other: <img src='./images/location-other.svg' alt='other' />
  },
  pets: {
    Dog: <img src='./images/pets-dogs.svg' alt='dogs' />,
    Cat: <img src='./images/pets-cats.svg' alt='cats' />,
    Both: <img src='./images/pets-both.svg' alt='cats and dogs' />,
    None: <img src='./images/pets-no-pets.svg' alt='no pets' />
  }
}

export const optionsIcons = (type, name, address) => {
  if (type === 'location') {
    switch (name) {
      case 'Home':
        return address?.type === 'Home'
          ? <img src='/images/location-home_active.svg' alt='home' />
          : <img src='/images/location-home.svg' alt='home' />
      case 'Hotel':
        return address?.type === 'Hotel'
          ? <img src='/images/location-hotel_active.svg' alt='hotel' />
          : <img src='/images/location-hotel.svg' alt='hotel' />
      case 'Office':
        return address?.type === 'Office'
          ? <img src='/images/location-office_active.svg' alt='office' />
          : <img src='/images/location-office.svg' alt='office' />
      case 'Other':
        return address?.type === 'Other'
          ? <img src='/images/location-other_active.svg' alt='other' />
          : <img src='/images/location-other.svg' alt='other' />
      default:
        break
    }
  } else if (type === 'pets') {
    switch (name) {
      case 'Dog':
        return address?.pets === 'Dog'
          ? <img src='/images/pets-dogs_active.svg' alt='dogs' />
          : <img src='/images/pets-dogs.svg' alt='dogs' />
      case 'Cat':
        return address?.pets === 'Cat'
          ? <img src='/images/pets-cats_active.svg' alt='cats' />
          : <img src='/images/pets-cats.svg' alt='cats' />
      case 'Both':
        return address?.pets === 'Both'
          ? <img src='/images/pets-both_active.svg' alt='cats and dogs' />
          : <img src='/images/pets-both.svg' alt='cats and dogs' />
      case 'None':
        return address?.pets === 'None'
          ? <img src='/images/pets-no-pets_active.svg' alt='no pets' />
          : <img src='/images/pets-no-pets.svg' alt='no pets' />
      default:
        break
    }
  }
}

export const DateTimeSection = styled(Section)`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;


  h2 {
    ${mq('max', '768px')} {
      font-size: 28px;
    }
  }

  .time {
    ${mq('max', '767px')} {
      margin-top: 5px;
    }

    ${mq('min', '768px')} {
      margin-left: 30px;
    }

    select {
      appearance: none;
      background: none;
      border: 0;
      border-radius: 0;
      font-family: Brown, sans-serif;
      height: 40px;

      &:focus {
        outline: 0;
      }
    }
  }

  .date-and-time {
    display: flex;
    margin-bottom: 24px;
    justify-content: center;
    align-items: flex-start;
    width: 100%;

    ${mq('max', '768px')} {
      flex-direction: column;
    }

    .date {
      width: 100%;
      max-width: 300px; 
    }

    .time {
      width: 100%;
      max-width: 300px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #000;

      select {
        flex: 1;
        color: #000;
        font-family: Euclid;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%;
        letter-spacing: 0.36px;
        border: none;
        display: flex;
        width: 100%;
        height: 54px;
        cursor: pointer;

        ${mq('max', '768px')} {
          font-size: 16px;
        }
      }
    }

    .date, .time {
      ${mq('max', '768px')} {
        max-width: unset;
      }
    }
  }

  .availability-search-status {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0 18px;

    text-align: center;
    font-family: Euclid;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 138%;
    letter-spacing: 0.64px;

    &.success {
      color: ${gsColors.cobalt};
    }

    &.error {
      color: ${gsColors.sunsetOrange};
    }

    &.pending {
      color: ${gsColors.saltBox};
    }
  }

  .arrival-window-content {
    font-family: Euclid;
    font-size: 16px;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    
    b {
      font-weight: 600;
    }
  }

  .alternate-time-buttons {
    display: flex;
    justify-content: center;
    margin-top: 12px;
    gap: 8px;
    flex-wrap: wrap;
  }

  .gs-checkbox-circle {
    input:checked + label {
      .box {
        background-color: ${gsColors.honeyFlower};
        // background-image: url(${checkmarkSvg});
        box-shadow: none;
      }
    }

    input[type='checkbox'] {
      display: none;
    }

    .box {
      background: ${gsColors.hintOfRed} no-repeat center;
      box-shadow: inset 0 0 2px 0 ${Color(gsColors.black).alpha(0.2).string()};
      border-radius: 50%;
      display: inline-block;
      position: relative;
      transition: all 250ms;
      width: 24px;
      height: 24px;
      margin-right: 10px;
      vertical-align: middle;

      img {
        padding-bottom: 1px;
      }
    }
  }
`

export const AddressDetailsSection = styled(Section)`
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mq('max', '768px')} {
    padding: 0 16px;
  }
  
  ${props => (props.disabled ? 'opacity: 0.1;' : '')}
  
  .inner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 26px 24px;
    max-width: 1050px;
    width: 100%;
    border-top: 1px solid #000;
    box-sizing: border-box;

    ${mq('max', '768px')} {
      max-width: initial;
      padding: 40px 0 24px;
    }

    h2 {
      ${mq('max', '768px')} {
        font-size: 28px !important;
      }
    }

    .address-details {
      width: 100%;
      max-width: 420px;

      ${mq('max', '768px')} {
        max-width: initial;
      }
  
      .container {
        width: 100%;
        padding-top: 24px;
  
  
        .directions-label {
          margin-top: 30px;
          font-family: Euclid;
          font-size: 14px;
          margin-bottom: 8px;
        }
        
        .location-pets-label {
          margin: 30px 0 20px;
          color: #000;
          font-family: Euclid;
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
          line-height: 138%;
          letter-spacing: 1.08px;
        }
  
        .option-group {
          width: 100%;
          display: flex;
          justify-content: space-between;
          gap: 8px;

          ${mq('max', '768px')} {
            flex-wrap: wrap;
          }
        }
      }
    }
  }  
`

export const OptionCss = css`
  display: flex;
  height: 54px;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid ${gsColors.lightTangerine};

  ${mq('max', '768px')} {
    flex: 40%;
  }

  span {
    color: #000;
    font-family: Euclid;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%;
    text-transform: capitalize;
  }

  &.active {
    border: 2px solid ${gsColors.sunsetOrange};
    color: ${gsColors.honeyFlower};
  }
`

export const SavedAddressesLabel = styled(Label)`
  max-width: 392px;
  display: block;
  font-size: 14px;
  letter-spacing: -0.2px;
  line-height: 1.86;

  ${mq('min', '768px')} {
    margin-left: auto;
    margin-right: auto;
  }
`
